import { useEffect, useState } from "react";

import { useHotelStore } from "../stores/HotelStore";
import { useProductStore } from "../stores/ProductStore";
import { DateInfo } from "../utilities/DateUtils";

import "../assets/scss/components/_hotel-product-information.scss";
import { Map } from "./Map";

export const HotelProductInformation = () => {
	const { hotelId, name, date, hotelInfo } = useHotelStore((state) => ({
		hotelId: state.hotelId,
		name: state.name,
		date: state.date,
		hotelInfo: state.hotelInfo,
	}));

	const { SetAddress, SetSelectedDeliveryDate } = useProductStore(({ SetAddress, SetSelectedDeliveryDate }) => {
		return { SetAddress, SetSelectedDeliveryDate };
	});

	useEffect(() => {
		console.log("Hotel Product Information:", {
			hotelId,
			name,
			date,
			hotelInfo,
		});

		if (hotelInfo.address.address_lat) setLatitude(hotelInfo.address.address_lat);
		if (hotelInfo.address.address_long) setLongitude(hotelInfo.address.address_long);

		if (hotelInfo.address) {
			SetAddress(hotelInfo.address);
		}

		if (date) {
			const niceDate = new Date(date);
			SetSelectedDeliveryDate(niceDate);
		}
	}, [hotelId, name, date, hotelInfo]);

	const [latitude, setLatitude] = useState(null);
	const [longitude, setLongitude] = useState(null);

	const niceDate = DateInfo(date, true, false);

	return (
		<section className="hotel-product-information">
			<div className="address-section">
				<h1>Delivering to {name}</h1>
				<div className="row">
					<div className="col-9">
						<p>We will send your gift to your hotel room at: </p>
						<div className="address">
							<span>{name}</span>
							<span>{hotelInfo.address.address_line1},</span>
							<span>{hotelInfo.address.address_line2}</span>
							<span>{hotelInfo.address.address_town}</span>
							<span>{hotelInfo.address.address_county}</span>
							<span>{hotelInfo.address.address_postcode}</span>
						</div>

						<div className="delivery-date">
							Your gift will be delivered ready for your stay on{" "}
							<strong>
								{niceDate.pretty.long.day} {niceDate.pretty.long.date} {niceDate.pretty.long.month}{" "}
								{niceDate.pretty.long.year}
							</strong>
						</div>
					</div>
					<div className="col-3">
						<Map lat={latitude ?? null} long={longitude ?? null} height={210} zoom={13} />
					</div>
				</div>
			</div>
		</section>
	);
};
